export const BASE_URL = 'https://www.stylecabbie.com/stylecabbie-server/api.php?method=';
export const BASE_URL_TRACKING = 'https://www.stylecabbie.com/stylecabbie-server/track_order.php/';
export const BASE_URL_PROMO_CODE = 'https://www.stylecabbie.com/stylecabbie-server/devapi.php?method=';
